import { VALUES_PER_PAGE } from 'components/pagination/constants';
import { action, extendObservable, observable } from 'mobx';
import { INITIAL_STATE } from 'modules/community/constants';

class CommunityStore {
  @observable communityComments = 0;

  constructor() {
    extendObservable(this, INITIAL_STATE);
  }

  @action
  setData({
    userId = '',
    page = 0,
    size = VALUES_PER_PAGE.TEN,
    content,
    totalElements
  }) {
    extendObservable(this, {
      comments: content,
      page,
      size,
      totalElements,
      userId
    });
  }

  @action
  setPage(page) {
    this.page = page;
  }

  @action
  setPerPage(perPage) {
    this.perPage = perPage;
  }

  @action
  setSortOptions(sortOptions) {
    this.sortOptions = sortOptions;
  }

  @action
  setSelectAll(selectAll = false) {
    this.selectAll = selectAll;
  }

  @action
  setComments(comments = []) {
    this.comments = comments;
  }

  @action
  setCommunityComments(communityComments = 0) {
    this.communityComments = communityComments;
  }

  @action
  setOptionsSnapshot(optionsSnapshot = {}) {
    this.optionsSnapshot = optionsSnapshot;
  }

  @action
  checkCommentByItem(item, checked) {
    const commentIndex = this.comments.findIndex(
      (comment) => comment.id === item.id
    );

    if (commentIndex > -1) {
      const newComments = Object.assign([...this.comments], {
        [commentIndex]: { ...this.comments[commentIndex], _checked: checked }
      });

      this.setComments(newComments);
    }
  }

  @action
  checkCommentsBySelectAll() {
    this.comments = this.comments.map((item) => ({
      ...item,
      _checked: this.selectAll
    }));
  }
}

export default new CommunityStore();
